import { useAuth, type AuthUser } from './use-auth';

export function useRole(): AuthUser['role'] | null {
  const { user } = useAuth();
  return user?.role ?? null;
}

export function useIsStaff(): boolean {
  const role = useRole();
  return role === 'owner' || role === 'manager' || role === 'agent' || role === 'crew';
}

export function useIsManagerOrAbove(): boolean {
  const role = useRole();
  return role === 'owner' || role === 'manager';
}
